export const LightDOM = (superClass) =>
    class LightDOMElement extends superClass {
        createRenderRoot() {
            return this;
        }
    };
